"use client";

// Header language switches (DEV-15362). Both now render the shared language
// picker (components/languagePicker), which lists every language the current
// page exists in. Kept as two names so the headers that use them need no edit.
import { LanguagePicker } from "../languagePicker/languagePicker.comp";

export const LangSwitchEs = ({ className = "" }: { className?: string }) => (
  <LanguagePicker className={className} />
);

// Small "EN" marker for links that lead to a page only available in English.
export const EnTag = () => (
  <span
    lang="en"
    title="Página en inglés"
    style={{
      fontSize: "0.7em",
      border: "1px solid currentColor",
      borderRadius: 3,
      padding: "0 3px",
      marginLeft: 4,
      opacity: 0.7,
      verticalAlign: "middle",
      fontWeight: 500,
    }}
  >
    EN
  </span>
);

// Language picker for the ENGLISH header (DEV-15362). Renders only on the
// English pages that exist in another language (src/i18n/locales.ts), so the
// other English pages are untouched.
export const LangSwitchEn = ({ className = "" }: { className?: string }) => (
  <LanguagePicker className={className} />
);
